import { useGeneratePDF } from '@/hooks/v2/resolution-886/useGeneratePDF';

interface UsePDFGenerateParams {
	report: any;
	organizationId: string;
	companyId: string;
	lastReviewId: string;
}

interface parameters {
	organization_id: string;
	company_id: string;
	report_id: string;
	review_id: string;
	locale: string;
	include_fields: string[];
}

export const usePDFGenerate = ({ report, organizationId, companyId, lastReviewId }: UsePDFGenerateParams) => {
	const { mutateAsync: generatePDF, isLoading: downloadPDFLoading } = useGeneratePDF();

	const handleDownloadPDF = async (values: any): Promise<void> => {
		const selectedSections = values.pdf_custom || [];
		const browserLanguage = window.navigator.language ?? 'en-US';

		const parameters: parameters = {
			organization_id: organizationId,
			company_id: companyId,
			report_id: report?.id,
			review_id: lastReviewId,
			locale: browserLanguage,
			include_fields: selectedSections
		};

		await generatePDF(parameters);
	};

	return {
		handleDownloadPDF,
		downloadPDFLoading
	};
};
